if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      console.log("TRIGGER!!");

      this.form = this.querySelector('form');
      this.querySelectorAll('form').forEach(form => {
        form.querySelector('[name=id]').disabled = false;
        form.addEventListener('submit', this.onSubmitHandler.bind(this));
      });
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButtons = this.querySelectorAll('[type="submit"]');
      this.submitButton = this.querySelector('[type="submit"]');

      if(this.querySelector('.monogram-container') != null) {
        this.hasMonogram = true;
        this.monogramInput = this.querySelector('input[name="properties[monogram]"]');
        this.monogramTrigger = this.querySelector('.monogram-letter-trigger');
        var monogramContainer = this.querySelector('.monogram-container');

        document.body.addEventListener('click', function() {
          if(monogramContainer.querySelector('.monogram-letters').classList.contains('show')) {
            monogramContainer.querySelector('.monogram-letters').classList.remove('show');
          }
        });

        this.monogramTrigger.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          this.classList.remove('emphasize');
          monogramContainer.querySelector('.monogram-letters').classList.add('show');
        });

        monogramContainer.querySelectorAll('.monogram-select-letter').forEach(letter => {
          letter.addEventListener('click', function(e) {
            e.preventDefault();
            if(monogramContainer.querySelector('.monogram-select-letter.selected') != null) {
              monogramContainer.querySelector('.monogram-select-letter.selected').classList.remove('selected');            
            }
            this.classList.add('selected');
            monogramContainer.querySelector('input[name="properties[monogram]"]').value = this.dataset.letter;
          });   
        })     
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (this.submitButton.classList.contains('needs-monogram') && this.hasMonogram && this.monogramInput.value == '') {
        this.monogramTrigger.classList.add('emphasize');
        return;
      }

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButtons.forEach(submitButton => {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButtons.forEach(submitButton => {
              submitButton.setAttribute('aria-disabled', true);
              submitButton.querySelector('span').classList.add('hidden');
              submitButton.querySelector('.sold-out-message').classList.remove('hidden');
            });
            this.error = true;
            return;
          }

          // Dispatch saved cart item event for customer accounts
          const gwCustomerAccounts = document.querySelector('gw-customer-accounts');
          if (gwCustomerAccounts) {
            const event = new CustomEvent('gw:saved-items-from-cart', {
              detail: { 
                productId: this.form.querySelector('[name="product-id"]').value,
                variantId: this.form.querySelector('[name="id"]').value,
                target: evt.target,
                extra: response
              }
            });

            gwCustomerAccounts.dispatchEvent(event);
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButtons.forEach(submitButton => {
            submitButton.classList.remove('loading');
            if (!this.error) submitButton.removeAttribute('aria-disabled');
          })
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
